<style lang="less" scoped>
.main::-webkit-scrollbar {width: 6px;}
/* 修改 滚动条的 下面 的 样式 */
.main::-webkit-scrollbar-track {background-color: white;-webkit-border-radius: 2em;-moz-border-radius: 2em;border-radius: 2em;}
/* 修改 滑块 */
.main::-webkit-scrollbar-thumb {background-color: #dcdfe6;-webkit-border-radius: 2em;-moz-border-radius: 2em;border-radius: 2em;}
/deep/ .el-dialog {height: 735px;font-family: '楷体';}
/deep/ .el-dialog__header {display: flex;justify-content: space-between;align-items: center;background: #303133;}
/deep/ .el-dialog__title,
/deep/ .el-dialog__headerbtn .el-dialog__close {color: white;}
/deep/ .el-dialog__body {padding: 20px;}
/deep/ .el-select {width: 95px;height: 56px;margin: 0px 20px;display: flex;align-items: center;}
.preview {display: flex;flex-direction: column;
  .head {width: 1920px;height: 56px;background-color: #323639;box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.6);
    .name {width: 120px;;height: 56px;color: #ffffff;float: left;line-height: 56px;
      span {color: #ffffff;height: 56px;line-height: 56px;}
    }
    .toolbar {height: 56px;
      .tools {height: 56px;display: flex;justify-content: center;
        .total {width: 80px;display: flex;align-items: center;justify-content: center;
          span {color: #3a8ee6;}
        }
      }
    }
  }
  .main {background: #525659;overflow-x: hidden;
    /deep/#pdf {width: 1200px;height: 881px;;margin: 0px auto;
      /deep/canvas {height: 881px !important;}
    }
  }
}
</style>
<template>
	<div class="preview">
    <div class="head">
      <div class="name">
        <!-- <span>pdf.pdf</span> -->
      </div>
      <div class="toolbar">
        <div class="tools">
          <el-button type="text" @click="FirstPage()">
            <el-tooltip effect="light" content="第一页" placement="top">
              <i class="el-icon-d-arrow-left"></i>
            </el-tooltip>
          </el-button>
          <el-button type="text" @click="changePdfPage(0)">
            <el-tooltip effect="light" content="上一页" placement="top">
              <i class="el-icon-arrow-left"></i>
            </el-tooltip>
          </el-button>
          <p class="total">
            <el-tooltip effect="light" content="当前页" placement="top">
              <b style="color:#3a8ee6;cursor:pointer;">{{ currentPage }}</b>
            </el-tooltip>
            <span class="">&nbsp;/&nbsp;</span>
            <el-tooltip effect="light" content="总页数" placement="top">
              <b style="color:#3a8ee6;cursor:pointer;">{{ pageCount }}</b>
            </el-tooltip>
          </p>
          <el-button type="text" @click="changePdfPage(1)">
            <el-tooltip effect="light" content="下一页" placement="top">
              <i class="el-icon-arrow-right"></i>
            </el-tooltip>
          </el-button>
          <el-button type="text" @click="lastPage()">
            <el-tooltip effect="light" content="最后一页" placement="top">
              <i class="el-icon-d-arrow-right"></i>
            </el-tooltip>
          </el-button>
          <el-button type="text" @click="setIsExit()" v-show="!isExit" style="margin-right:10px;">
            <el-tooltip effect="light" content="页码选择" placement="top">
              <i class="el-icon-setting"></i>
            </el-tooltip>
          </el-button>
          <el-tooltip effect="light" content="页码选择" placement="top" v-show="isExit">
            <el-select v-model="value" placeholder="请选择" @change="pageSelect" size="mini">
              <el-option v-for="item in pageCount" :key="item" :label="'第 '+item+' 页'" :value="item"></el-option>
            </el-select>
          </el-tooltip>
        
          <!-- <el-button type="text" @click="scaleD()">
            <el-tooltip effect="light" content="放大" placement="top">
              <i class="el-icon-zoom-in"></i>
            </el-tooltip>
          </el-button>
          <el-button type="text" class="">
            <el-tooltip effect="light" content="当前比列" placement="top">
              <span>100%</span>
            </el-tooltip>
          </el-button>
          <el-button type="text" @click="scaleX()">
            <el-tooltip effect="light" content="缩小" placement="top">
              <i class="el-icon-zoom-out"></i>
            </el-tooltip>
          </el-button> -->

          <el-button type="text" @click="clock()">
            <el-tooltip effect="light" content="顺时针旋转" placement="top">
              <i class="el-icon-refresh-right"></i>
            </el-tooltip>
          </el-button>
          <el-button type="text" @click="counterClock()">
            <el-tooltip effect="light" content="逆时针旋转" placement="top">
              <i class="el-icon-refresh-left"></i>
            </el-tooltip>
          </el-button>
          <el-button type="text" @click="downPDF">
            <el-tooltip effect="light" content="下载" placement="top">
              <i class="el-icon-download"></i>
            </el-tooltip>
          </el-button>
          <el-button type="text" @click="printPDF">
            <el-tooltip effect="light" content="打印" placement="top">
              <i class="el-icon-printer"></i>
            </el-tooltip>
          </el-button>
        </div>
      </div>
    </div>
    <div class="main" id="main">
      <pdf
        class="pdf"
        ref="pdf"
        id="pdf"
        :src="src"
        :page="currentPage"
        :rotate="pageRotate"
        :num-pages="pageCount"
        @num-pages="pageCount  = $event"
        @page-loaded="currentPage = $event"
        @loaded="loadPdfHandler">
      </pdf>
    </div>
	</div>
</template>
 
<script>
import pdf from 'vue-pdf'
export default {
  components: {
    pdf
  },
  data()
  {
    return {
      isExit: false,
      value: 1,
      src: '',
      currentPage: 0, // pdf文件当前页码
      pageCount: 0, // pdf文件总页数
      scale: 1,
      pageRotate: 0,
      isLogin: false
    }
  },
  created()
  {
    this.src = this.$route.query.url
    this.getUser()
  },
  methods: {
    getUser()
    {
      if (!localStorage.getItem('username'))
      {
        this.pageCount = 1
        this.isLogin = false
      }
      else
        this.isLogin = true
    },
    // pdf加载时
    loadPdfHandler()
    {
      this.value = this.currentPage = 1 // 加载的时候先加载第一页
    },
    // 第一页
    FirstPage()
    {
      this.value = this.currentPage = 1
      this.isExit = false
    },
    // 最后一页
    lastPage()
    {
      if (this.isLogin)
      {
        this.value = this.currentPage = this.pageCount
        this.isExit = false
      }
      else
        this.$message({message: '登录后可查看更多内容', type: 'warning', customClass: 'mzindex'})
    },
    // 改变PDF页码,val 传过来区分上一页下一页的值,0 上一页,1 下一页
    changePdfPage(val)
    {
      if (val === 0 && this.currentPage > 1)
        this.currentPage--
      if (val === 1 && this.currentPage < this.pageCount)
        this.currentPage++
      else if (val === 1 && this.currentPage > this.pageCount)
        this.$message({message: '登录后可查看更多内容', type: 'warning', customClass: 'mzindex'})

      this.value = this.currentPage
      this.isExit = false
      document.getElementById('main').scrollTop = 0
    },
    // 页码选择
    pageSelect()
    {
      if (this.isLogin)
      {
        this.currentPage = this.value
        this.isExit = false
        document.getElementById('main').scrollTop = 0
      }
      else
        this.$message({message: '登录后可查看更多内容', type: 'warning', customClass: 'mzindex'})
    },
    // 控制下拉选择框显示隐藏
    setIsExit()
    {
      this.isExit = true
    },
    // 放大--待定
    scaleD()
    {
      this.scale += 5
      this.$refs.pdf.$el.style.width = parseInt(this.scale) + '%'
      // this.$refs.pdf.$el.style.transform = `scale(${this.scale}, ${this.scale})`
    },
    // 缩小--待定
    scaleX()
    {
      if (this.scale === 100)
        return
      this.scale += -5
      this.$refs.pdf.$el.style.width = parseInt(this.scale) + '%'
      // this.$refs.pdf.$el.style.transform = `scale(${this.scale}, ${this.scale})`
    },

    // 顺时针
    clock()
    {
      this.pageRotate += 90
    },
    // 逆时针
    counterClock()
    {
      this.pageRotate -= 90
    },
    // 下载
    downPDF()
    {
      if (this.isLogin)
      {
        var url = this.src
        var tempLink = document.createElement('a')
        tempLink.style.display = 'none'
        tempLink.href = url
        tempLink.setAttribute('download', '下载.pdf')
        if (typeof tempLink.download === 'undefined')
          tempLink.setAttribute('target', '_blank')
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
      }
      else
        this.$message({message: '登录后可进行相关操作', type: 'warning', customClass: 'mzindex'})
    },
    // 打印
    printPDF()
    {
      if (this.isLogin)
        this.$refs.pdf.print()
      else
        this.$message({message: '登录后可进行相关操作', type: 'warning', customClass: 'mzindex'})
    }
  }
}
</script>
 
 



// WEBPACK FOOTER //
// src/plugins/app/assembly/PDFfile.vue